export const whatProductData = {
  productData: {
    title: 'What product did you purchase?',
    placeHolder: 'e.g. TV, fridge freezer',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/510b60add388-tooliconshopping.jpg',
    },
  },
  serviceData: {
    title: 'What service did you purchase?',
    placeHolder: 'e.g. Carpet fitting',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/c75cd4e69e2c-tooliconspanner.jpg',
    },
  },
}
